import { useEffect, useState } from 'react';

export const useIsSafari = () => {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent.toLowerCase();
      // Safari but not Chrome or Edge
      const safari = ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');
      setIsSafari(safari);
    }
  }, []);

  return isSafari;
};
